import React, {Fragment} from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import ViewDetails from './ViewDetails'


const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '10px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    }
})

class RecertificatePrint extends React.Component {

    constructor(props){
      super(props)
    }
    
  
   render(props) {
    const record= this.props.record
    const classes = this.props.classes
    
   
    return(
        <div className={classes.root}>
            <div className={classes.title}>
                <p className={classes.p}>Annual Recertification Form</p>
                <h3>{(record && record.name)}</h3>
                <p className={classes.p}>Printed on {moment(Date()).format('MM/DD/yyyy')}</p>
            </div>

            <div className={classes.body}> 
           
                <table width="100%" >
                    <tbody>
                        <tr>
                            <td width="20%">Employee Name:</td><td colSpan="3">{(record && record.emp_name)}</td>
                           
                        </tr>
                        <tr>
                            <td width="20%">Employee Titile:</td><td colSpan="3">{(record && record.emp_title)}</td>
                           
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                        <td colSpan="4">
                            <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                                <tbody>
                                    <tr>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"60%", textAlign: "center"}}>Procedure</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date of Reading</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"10%", textAlign: "center"}}>Employee Initial</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date</th>
                                    </tr>
                                    <ViewDetails records={record}  />  
                                </tbody>
                            </table>
                    
                        </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        {
                        (record && record.isphy_sub )?(
                        <Fragment>
                        <tr>
                            <td  colSpan="4">
                            <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                            <tbody>
                                <tr>
                                    <td>
                                        <table style={{ width:"100%"}}>
                                        <tbody>
                                            <tr>
                                                <td colSpan="4"><b>For Physician Substitute ONLY</b></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">Physical Examination performed in presence of CMD on Date:</td>
                                                <td>{(record && record.cmd_date && moment(record.cmd_date).format('MM/DD/yyyy'))}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4">
                                                <u>CMD Comments:</u>{(record && record.cmd_comments)}
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Center Medical Director Signature:</td>
                                                <td>{record && record.cmd_sign && moment(record.cmd_sign).format('MM/DD/yyyy')}</td>
                                                <td>&nbsp;Date:</td>
                                                <td>{record && record.cmd_sign_date && moment(record.cmd_sign_date).format('MM/DD/yyyy')}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                            </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        </Fragment>): null
                        }
                <tr>
                    <td colSpan="4">
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td>Employee Name:</td><td>{(record && record.emp_name)}</td>
                                    <td>Signature:</td><td>{(record && record.emp_sign)}</td>
                                    <td>Date:</td><td>{(record && record.emp_sign_date  && moment(record.emp_sign_date).format('MM/DD/yyyy') )}</td>
                                </tr>
                                <tr>
                                    <td>Management/QA review:</td><td>{(record && record.qa_review)}</td>
                                    <td>Signature:</td><td>{(record && record.qa_sign)}</td>
                                    <td>Date:</td><td>{(record && record.qa_sign_date && moment(record.qa_sign_date).format('MM/DD/yyyy'))}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                </tbody>
            </table>

        </div>
    </div>
    )
  }
}

export default RecertificatePrint